import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import {
    Container,
    Row,
    Col,
    Table,
    Form,
    Button,
    Card,
} from "react-bootstrap";
import { FaTrash, FaEdit, FaEye, FaPlus, FaComments, FaTasks } from "react-icons/fa";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import "./CustomerList.css";
import axios from "axios";

const SubTaskList = () => {
    const [subTaskList, setSubTaskList] = useState([]);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const { task_id } = useParams();

    useEffect(() => {
        axios.post(`${API_BASE_URL}sub_task_list.php`, { task_id: task_id })
            .then((response) => {
                if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
                    setSubTaskList(response.data.body);

                } else {
                    console.error("Error Fetching Data:", response.data.head.msg);
                    setSubTaskList([]);
                }
            })
            .catch((error) => {
                console.error("API Error:", error);
                setSubTaskList([]);
            }).finally(() => {
            });
    }, []);



    // Pagination over filtered results
    const {
        currentPage,
        totalPages,
        currentItems,
        handlePageChange,
        indexOfFirstItem,
    } = usePagination(subTaskList, 25); // 4 tasks per page


    return (
        <Container fluid className="my-4 outer-container">
            <div className="d-flex justify-content-between mb-2">
                <p></p>
                <h2 className="text-center">Sub Task List</h2>
                <Button className="btn-top me-2" onClick={() => window.history.back()}>
                    Back
                </Button>
            </div>
            {currentItems.length === 0 && (
                <Container fluid className="outer-container my-4">
                    <Row>
                        <Col>
                            <div className="not-found-box">Loading...</div>
                        </Col>
                    </Row>
                </Container>
            )}
            {/* <Row className="mb-3">
        <Col md={12}>
          <div className="d-flex justify-content-end">
            <Link to="/addtask" className="btn-top">
              <FaPlus /> Add Task
            </Link>
          </div>
        </Col>
      </Row> */}

            {/* Filters row styled like PermissionLeaveList */}
            {/* <Row className="mb-3">
        <Col md={4} className="mb-2">
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Select
              name="assigned_to"
              value={search}
               onChange={(e) => setSearch(e.target.value)}
              className="custom-select-arrow"
            >
              <option value="">Select Name</option>
              {customerList.map((user) => (
                <option key={user.user_id} value={user.user_id}>
                  {user.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={2} className="d-flex mt-4">
          <Button
            className="btn-top"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </Col>

        <Col md={3} className="mb-2">
          <Form.Label>From</Form.Label>
          <Form.Control
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            placeholder="From Date"
          />
        </Col>



        <Col md={3} className="mb-2">
          <Form.Label>To</Form.Label>
          <Form.Control
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            placeholder="To Date"
          />
        </Col>

        
      </Row> */}


            {/* <Row className="g-3">
        <Col md={4}>
          <Card className="gradient-box gradient-red text-white">
            <Card.Body>
              <h5>Pending</h5>
              <p style={{ fontSize: "20px" }}>{pending}</p>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="gradient-box gradient-blue text-white">
            <Card.Body>
              <h5>Processing</h5>
              <p style={{ fontSize: "20px" }}>{processing}</p>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="gradient-box gradient-green text-white">
            <Card.Body>
              <h5>Completed</h5>
              <p style={{ fontSize: "20px" }}>{completed}</p>
            </Card.Body>
          </Card>
        </Col>
      </Row> */}

            <div className="table-pagination-wrapper">
                <div className="table-pagination-content">
                    <Table bordered responsive className="table-striped my-3 customer-table">
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Due Date</th>
                                <th>Sub Task</th>
                                <th>Description</th>
                                <th>Assigned To</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((task, i) => (
                                <tr key={task.sub_task_id}>
                                    {/* <td>{indexOfFirstItem + i + 1}</td> */}
                                    <td>{currentItems.length - (indexOfFirstItem + i)}</td>
                                    <td>{task.due_date}</td>
                                    <td>{task.sub_name}</td>
                                    <td>{task.description}</td>
                                    <td>{task.assigned_to_name}</td>
                                </tr>
                            ))}
                            {/* {currentItems.length === 0 && (
                <tr>
                  <td colSpan="10" className="text-center">
                    No tasks found
                  </td>
                </tr>
              )} */}
                        </tbody>
                    </Table>
                </div>
            </div>

            {totalPages > 1 && (
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />
            )}
        </Container>
    );
};

export default SubTaskList;
